import { ActionIcon, Badge, Loader } from '@mantine/core';
import { Icon } from '@/components/Icon';
import styles from './GroupAdmins.module.sass';

const LAYOUT = {
  REMOVE_ICON_SIZE: 14,
};

type RemovableScopeChipProps = {
  label: string;
  isRemoving: boolean;
  onRemove: () => void;
};

export const RemovableScopeChip = ({ label, isRemoving, onRemove }: RemovableScopeChipProps) => (
  <Badge variant="default" color="black" className={styles.scopeChip} pr={4}>
    <span className={styles.scopeChipLabel}>{label}</span>
    <ActionIcon
      aria-label={`Remove ${label}`}
      variant="transparent"
      size="xs"
      color="gray"
      className={styles.removeChipButton}
      onClick={onRemove}
      disabled={isRemoving}
    >
      {isRemoving ? <Loader size="xs" color="gray" /> : <Icon name="IconX" size={LAYOUT.REMOVE_ICON_SIZE} />}
    </ActionIcon>
  </Badge>
);
